import {DocumentSnapshot} from "store/firebase";
import { TastingAnswer } from "./reducer"

export const answerFromDoc = (
  doc: DocumentSnapshot,
  eventId?: string
): TastingAnswer => {
  return {
    id: doc.id,
    eventId,
    beers: doc.data()?.beers,
    asterisks: doc.data()?.asterisks,
    doubleAsterisks: doc.data()?.doubleAsterisks,
    ratings: doc.data()?.ratings,
    changes: doc.data()?.changes,
    rounds: doc.data()?.rounds,
    secondaryBeers: doc.data()?.secondaryBeers,
    notes: doc.data()?.notes,
    lottoLoco: doc.data()?.lottoLoco,
  };
};

export const answerToDocData = (answer: TastingAnswer) => {
    return {
        ...(answer.beers ? {beers: answer.beers} : {}),
        ...(answer.asterisks ? {asterisks: answer.asterisks} : {}),
        ...(answer.doubleAsterisks ? {doubleAsterisks: answer.doubleAsterisks} : {}),
        ...(answer.ratings ? {ratings: answer.ratings} : {}),
        ...(answer.changes ? {changes: answer.changes} : {}),
        ...(answer.rounds ? {rounds: answer.rounds} : {}),
        ...(answer.secondaryBeers ? {secondaryBeers: answer.secondaryBeers} : {}),
        ...(answer.notes ? {notes: answer.notes} : {}),
        ...(answer.lottoLoco ? {lottoLoco: answer.lottoLoco} : {}),
    }
}

const emptyList = (i = 0) => {
  let list = Array(i);
  for (i; i > 0; i--) list[i - 1] = null;
  return list;
};

export const newAnswersData = (rounds: number) => {
  return {
    beers: [...emptyList(rounds)],
    asterisks: [...emptyList(rounds)],
    doubleAsterisks: [...emptyList(rounds)],
    ratings: [...emptyList(rounds)],
    changes: [...emptyList(rounds)],
    secondaryBeers: [...emptyList(rounds)],
    notes: [...emptyList(rounds)],
    lottoLoco: Array(rounds).fill(false),
    rounds,
  };
};